// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as AcceptRoleTokenRouteImport } from './routes/accept-role/$token'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminSplatRouteImport } from './routes/admin/$'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as FSlugRouteImport } from './routes/f/$slug'
import { Route as HealthIndexRouteImport } from './routes/health/index'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as InstallIndexRouteImport } from './routes/install/index'
import { Route as LegalIndexRouteImport } from './routes/legal/index'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as OsIndexRouteImport } from './routes/os/index'
import { Route as ThemeDemoIndexRouteImport } from './routes/theme-demo/index'
import { Route as VrPlaygroundIndexRouteImport } from './routes/vr-playground/index'
import { Route as AdminAccountingIndexRouteImport } from './routes/_admin/accounting/index'
import { Route as AdminAiIndexRouteImport } from './routes/_admin/ai/index'
import { Route as AdminArchivingIndexRouteImport } from './routes/_admin/archiving/index'
import { Route as AdminAuditLogsIndexRouteImport } from './routes/_admin/audit-logs/index'
import { Route as AdminCalendarIndexRouteImport } from './routes/_admin/calendar/index'
import { Route as AdminClientsIndexRouteImport } from './routes/_admin/clients/index'
import { Route as AdminCommunityIndexRouteImport } from './routes/_admin/community/index'
import { Route as AdminContentManagementIndexRouteImport } from './routes/_admin/content-management/index'
import { Route as AdminCortexMeshIndexRouteImport } from './routes/_admin/cortex-mesh/index'
import { Route as AdminCortexIndexRouteImport } from './routes/_admin/cortex/index'
import { Route as AdminCortexMarketplaceRouteImport } from './routes/_admin/cortex/marketplace'
import { Route as AdminDashboardIndexRouteImport } from './routes/_admin/dashboard/index'
import { Route as AdminDocumentationIndexRouteImport } from './routes/_admin/documentation/index'
import { Route as AdminDocumentsIndexRouteImport } from './routes/_admin/documents/index'
import { Route as AdminGamificationIndexRouteImport } from './routes/_admin/gamification/index'
import { Route as AdminHealthCoachingIndexRouteImport } from './routes/_admin/health-coaching/index'
import { Route as AdminKnowledgeAtlasIndexRouteImport } from './routes/_admin/knowledge-atlas/index'
import { Route as AdminLeaderboardsIndexRouteImport } from './routes/_admin/leaderboards/index'
import { Route as AdminNexusIndexRouteImport } from './routes/_admin/nexus/index'
import { Route as AdminNotebooksIndexRouteImport } from './routes/_admin/notebooks/index'
import { Route as AdminNotebooksNotebookIdRouteImport } from './routes/_admin/notebooks/$notebookId'
import { Route as AdminNotificationsIndexRouteImport } from './routes/_admin/notifications/index'
import { Route as AdminOpportunitiesIndexRouteImport } from './routes/_admin/opportunities/index'
import { Route as AdminOrganizationIndexRouteImport } from './routes/_admin/organization/index'
import { Route as AdminPartnersIndexRouteImport } from './routes/_admin/partners/index'
import { Route as AdminProfileIndexRouteImport } from './routes/_admin/profile/index'
import { Route as AdminProgressReportsIndexRouteImport } from './routes/_admin/progress-reports/index'
import { Route as AdminProjectsIndexRouteImport } from './routes/_admin/projects/index'
import { Route as AdminProjectsProjectIdRouteImport } from './routes/_admin/projects/$projectId'
import { Route as AdminSalesPortalIndexRouteImport } from './routes/_admin/sales-portal/index'
import { Route as AdminSeasonsIndexRouteImport } from './routes/_admin/seasons/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/_admin/settings/index'
import { Route as AdminStatsIndexRouteImport } from './routes/_admin/stats/index'
import { Route as AdminStreaksIndexRouteImport } from './routes/_admin/streaks/index'
import { Route as AdminSubscriptionsIndexRouteImport } from './routes/_admin/subscriptions/index'
import { Route as AdminTasksIndexRouteImport } from './routes/_admin/tasks/index'
import { Route as AdminTimeManagementIndexRouteImport } from './routes/_admin/time-management/index'
import { Route as AdminTodosIndexRouteImport } from './routes/_admin/todos/index'
import { Route as AdminUsersIndexRouteImport } from './routes/_admin/users/index'
import { Route as AdminWebsiteDigestIndexRouteImport } from './routes/_admin/website-digest/index'
import { Route as AdminWorkflowsIndexRouteImport } from './routes/_admin/workflows/index'
import { Route as AuthCallbackIndexRouteImport } from './routes/auth/callback/index'
import { Route as AuthConfirmIndexRouteImport } from './routes/auth/confirm/index'
import { Route as AuthLinkedinCallbackRouteImport } from './routes/auth/linkedin/callback'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/auth/reset-password/index'
import { Route as AuthTiktokCallbackRouteImport } from './routes/auth/tiktok/callback'
import { Route as AdminAdminSettingsIndexRouteImport } from './routes/_admin/admin/settings/index'
import { Route as AdminIntegrationsCrmIndexRouteImport } from './routes/_admin/integrations/crm/index'
import { Route as AdminIntegrationsXeroIndexRouteImport } from './routes/_admin/integrations/xero/index'
import { Route as AuthGoogleCallbackIndexRouteImport } from './routes/auth/google/callback/index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const AcceptRoleTokenRoute = AcceptRoleTokenRouteImport.update({
            id: '/accept-role/$token',path: '/accept-role/$token',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/admin/$',path: '/admin/$',getParentRoute: () => rootRouteImport
          })
const AuthIndexRoute = AuthIndexRouteImport.update({
            id: '/auth/',path: '/auth/',getParentRoute: () => rootRouteImport
          })
const FSlugRoute = FSlugRouteImport.update({
            id: '/f/$slug',path: '/f/$slug',getParentRoute: () => rootRouteImport
          })
const HealthIndexRoute = HealthIndexRouteImport.update({
            id: '/health/',path: '/health/',getParentRoute: () => rootRouteImport
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/home/',path: '/home/',getParentRoute: () => rootRouteImport
          })
const InstallIndexRoute = InstallIndexRouteImport.update({
            id: '/install/',path: '/install/',getParentRoute: () => rootRouteImport
          })
const LegalIndexRoute = LegalIndexRouteImport.update({
            id: '/legal/',path: '/legal/',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const OsIndexRoute = OsIndexRouteImport.update({
            id: '/os/',path: '/os/',getParentRoute: () => rootRouteImport
          })
const ThemeDemoIndexRoute = ThemeDemoIndexRouteImport.update({
            id: '/theme-demo/',path: '/theme-demo/',getParentRoute: () => rootRouteImport
          })
const VrPlaygroundIndexRoute = VrPlaygroundIndexRouteImport.update({
            id: '/vr-playground/',path: '/vr-playground/',getParentRoute: () => rootRouteImport
          })
const AdminAccountingIndexRoute = AdminAccountingIndexRouteImport.update({
            id: '/accounting/',path: '/accounting/',getParentRoute: () => AdminRoute
          })
const AdminAiIndexRoute = AdminAiIndexRouteImport.update({
            id: '/ai/',path: '/ai/',getParentRoute: () => AdminRoute
          })
const AdminArchivingIndexRoute = AdminArchivingIndexRouteImport.update({
            id: '/archiving/',path: '/archiving/',getParentRoute: () => AdminRoute
          })
const AdminAuditLogsIndexRoute = AdminAuditLogsIndexRouteImport.update({
            id: '/audit-logs/',path: '/audit-logs/',getParentRoute: () => AdminRoute
          })
const AdminCalendarIndexRoute = AdminCalendarIndexRouteImport.update({
            id: '/calendar/',path: '/calendar/',getParentRoute: () => AdminRoute
          })
const AdminClientsIndexRoute = AdminClientsIndexRouteImport.update({
            id: '/clients/',path: '/clients/',getParentRoute: () => AdminRoute
          })
const AdminCommunityIndexRoute = AdminCommunityIndexRouteImport.update({
            id: '/community/',path: '/community/',getParentRoute: () => AdminRoute
          })
const AdminContentManagementIndexRoute = AdminContentManagementIndexRouteImport.update({
            id: '/content-management/',path: '/content-management/',getParentRoute: () => AdminRoute
          })
const AdminCortexMeshIndexRoute = AdminCortexMeshIndexRouteImport.update({
            id: '/cortex-mesh/',path: '/cortex-mesh/',getParentRoute: () => AdminRoute
          })
const AdminCortexIndexRoute = AdminCortexIndexRouteImport.update({
            id: '/cortex/',path: '/cortex/',getParentRoute: () => AdminRoute
          })
const AdminCortexMarketplaceRoute = AdminCortexMarketplaceRouteImport.update({
            id: '/cortex/marketplace',path: '/cortex/marketplace',getParentRoute: () => AdminRoute
          })
const AdminDashboardIndexRoute = AdminDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => AdminRoute
          })
const AdminDocumentationIndexRoute = AdminDocumentationIndexRouteImport.update({
            id: '/documentation/',path: '/documentation/',getParentRoute: () => AdminRoute
          })
const AdminDocumentsIndexRoute = AdminDocumentsIndexRouteImport.update({
            id: '/documents/',path: '/documents/',getParentRoute: () => AdminRoute
          })
const AdminGamificationIndexRoute = AdminGamificationIndexRouteImport.update({
            id: '/gamification/',path: '/gamification/',getParentRoute: () => AdminRoute
          })
const AdminHealthCoachingIndexRoute = AdminHealthCoachingIndexRouteImport.update({
            id: '/health-coaching/',path: '/health-coaching/',getParentRoute: () => AdminRoute
          })
const AdminKnowledgeAtlasIndexRoute = AdminKnowledgeAtlasIndexRouteImport.update({
            id: '/knowledge-atlas/',path: '/knowledge-atlas/',getParentRoute: () => AdminRoute
          })
const AdminLeaderboardsIndexRoute = AdminLeaderboardsIndexRouteImport.update({
            id: '/leaderboards/',path: '/leaderboards/',getParentRoute: () => AdminRoute
          })
const AdminNexusIndexRoute = AdminNexusIndexRouteImport.update({
            id: '/nexus/',path: '/nexus/',getParentRoute: () => AdminRoute
          })
const AdminNotebooksIndexRoute = AdminNotebooksIndexRouteImport.update({
            id: '/notebooks/',path: '/notebooks/',getParentRoute: () => AdminRoute
          })
const AdminNotebooksNotebookIdRoute = AdminNotebooksNotebookIdRouteImport.update({
            id: '/notebooks/$notebookId',path: '/notebooks/$notebookId',getParentRoute: () => AdminRoute
          })
const AdminNotificationsIndexRoute = AdminNotificationsIndexRouteImport.update({
            id: '/notifications/',path: '/notifications/',getParentRoute: () => AdminRoute
          })
const AdminOpportunitiesIndexRoute = AdminOpportunitiesIndexRouteImport.update({
            id: '/opportunities/',path: '/opportunities/',getParentRoute: () => AdminRoute
          })
const AdminOrganizationIndexRoute = AdminOrganizationIndexRouteImport.update({
            id: '/organization/',path: '/organization/',getParentRoute: () => AdminRoute
          })
const AdminPartnersIndexRoute = AdminPartnersIndexRouteImport.update({
            id: '/partners/',path: '/partners/',getParentRoute: () => AdminRoute
          })
const AdminProfileIndexRoute = AdminProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => AdminRoute
          })
const AdminProgressReportsIndexRoute = AdminProgressReportsIndexRouteImport.update({
            id: '/progress-reports/',path: '/progress-reports/',getParentRoute: () => AdminRoute
          })
const AdminProjectsIndexRoute = AdminProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => AdminRoute
          })
const AdminProjectsProjectIdRoute = AdminProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AdminRoute
          })
const AdminSalesPortalIndexRoute = AdminSalesPortalIndexRouteImport.update({
            id: '/sales-portal/',path: '/sales-portal/',getParentRoute: () => AdminRoute
          })
const AdminSeasonsIndexRoute = AdminSeasonsIndexRouteImport.update({
            id: '/seasons/',path: '/seasons/',getParentRoute: () => AdminRoute
          })
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => AdminRoute
          })
const AdminStatsIndexRoute = AdminStatsIndexRouteImport.update({
            id: '/stats/',path: '/stats/',getParentRoute: () => AdminRoute
          })
const AdminStreaksIndexRoute = AdminStreaksIndexRouteImport.update({
            id: '/streaks/',path: '/streaks/',getParentRoute: () => AdminRoute
          })
const AdminSubscriptionsIndexRoute = AdminSubscriptionsIndexRouteImport.update({
            id: '/subscriptions/',path: '/subscriptions/',getParentRoute: () => AdminRoute
          })
const AdminTasksIndexRoute = AdminTasksIndexRouteImport.update({
            id: '/tasks/',path: '/tasks/',getParentRoute: () => AdminRoute
          })
const AdminTimeManagementIndexRoute = AdminTimeManagementIndexRouteImport.update({
            id: '/time-management/',path: '/time-management/',getParentRoute: () => AdminRoute
          })
const AdminTodosIndexRoute = AdminTodosIndexRouteImport.update({
            id: '/todos/',path: '/todos/',getParentRoute: () => AdminRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AdminRoute
          })
const AdminWebsiteDigestIndexRoute = AdminWebsiteDigestIndexRouteImport.update({
            id: '/website-digest/',path: '/website-digest/',getParentRoute: () => AdminRoute
          })
const AdminWorkflowsIndexRoute = AdminWorkflowsIndexRouteImport.update({
            id: '/workflows/',path: '/workflows/',getParentRoute: () => AdminRoute
          })
const AuthCallbackIndexRoute = AuthCallbackIndexRouteImport.update({
            id: '/auth/callback/',path: '/auth/callback/',getParentRoute: () => rootRouteImport
          })
const AuthConfirmIndexRoute = AuthConfirmIndexRouteImport.update({
            id: '/auth/confirm/',path: '/auth/confirm/',getParentRoute: () => rootRouteImport
          })
const AuthLinkedinCallbackRoute = AuthLinkedinCallbackRouteImport.update({
            id: '/auth/linkedin/callback',path: '/auth/linkedin/callback',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
            id: '/auth/reset-password/',path: '/auth/reset-password/',getParentRoute: () => rootRouteImport
          })
const AuthTiktokCallbackRoute = AuthTiktokCallbackRouteImport.update({
            id: '/auth/tiktok/callback',path: '/auth/tiktok/callback',getParentRoute: () => rootRouteImport
          })
const AdminAdminSettingsIndexRoute = AdminAdminSettingsIndexRouteImport.update({
            id: '/admin/settings/',path: '/admin/settings/',getParentRoute: () => AdminRoute
          })
const AdminIntegrationsCrmIndexRoute = AdminIntegrationsCrmIndexRouteImport.update({
            id: '/integrations/crm/',path: '/integrations/crm/',getParentRoute: () => AdminRoute
          })
const AdminIntegrationsXeroIndexRoute = AdminIntegrationsXeroIndexRouteImport.update({
            id: '/integrations/xero/',path: '/integrations/xero/',getParentRoute: () => AdminRoute
          })
const AuthGoogleCallbackIndexRoute = AuthGoogleCallbackIndexRouteImport.update({
            id: '/auth/google/callback/',path: '/auth/google/callback/',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminCortexMarketplaceRoute: AdminCortexMarketplaceRoute,AdminNotebooksNotebookIdRoute: AdminNotebooksNotebookIdRoute,AdminProjectsProjectIdRoute: AdminProjectsProjectIdRoute,AdminAccountingIndexRoute: AdminAccountingIndexRoute,AdminAiIndexRoute: AdminAiIndexRoute,AdminArchivingIndexRoute: AdminArchivingIndexRoute,AdminAuditLogsIndexRoute: AdminAuditLogsIndexRoute,AdminCalendarIndexRoute: AdminCalendarIndexRoute,AdminClientsIndexRoute: AdminClientsIndexRoute,AdminCommunityIndexRoute: AdminCommunityIndexRoute,AdminContentManagementIndexRoute: AdminContentManagementIndexRoute,AdminCortexMeshIndexRoute: AdminCortexMeshIndexRoute,AdminCortexIndexRoute: AdminCortexIndexRoute,AdminDashboardIndexRoute: AdminDashboardIndexRoute,AdminDocumentationIndexRoute: AdminDocumentationIndexRoute,AdminDocumentsIndexRoute: AdminDocumentsIndexRoute,AdminGamificationIndexRoute: AdminGamificationIndexRoute,AdminHealthCoachingIndexRoute: AdminHealthCoachingIndexRoute,AdminKnowledgeAtlasIndexRoute: AdminKnowledgeAtlasIndexRoute,AdminLeaderboardsIndexRoute: AdminLeaderboardsIndexRoute,AdminNexusIndexRoute: AdminNexusIndexRoute,AdminNotebooksIndexRoute: AdminNotebooksIndexRoute,AdminNotificationsIndexRoute: AdminNotificationsIndexRoute,AdminOpportunitiesIndexRoute: AdminOpportunitiesIndexRoute,AdminOrganizationIndexRoute: AdminOrganizationIndexRoute,AdminPartnersIndexRoute: AdminPartnersIndexRoute,AdminProfileIndexRoute: AdminProfileIndexRoute,AdminProgressReportsIndexRoute: AdminProgressReportsIndexRoute,AdminProjectsIndexRoute: AdminProjectsIndexRoute,AdminSalesPortalIndexRoute: AdminSalesPortalIndexRoute,AdminSeasonsIndexRoute: AdminSeasonsIndexRoute,AdminSettingsIndexRoute: AdminSettingsIndexRoute,AdminStatsIndexRoute: AdminStatsIndexRoute,AdminStreaksIndexRoute: AdminStreaksIndexRoute,AdminSubscriptionsIndexRoute: AdminSubscriptionsIndexRoute,AdminTasksIndexRoute: AdminTasksIndexRoute,AdminTimeManagementIndexRoute: AdminTimeManagementIndexRoute,AdminTodosIndexRoute: AdminTodosIndexRoute,AdminUsersIndexRoute: AdminUsersIndexRoute,AdminWebsiteDigestIndexRoute: AdminWebsiteDigestIndexRoute,AdminWorkflowsIndexRoute: AdminWorkflowsIndexRoute,AdminAdminSettingsIndexRoute: AdminAdminSettingsIndexRoute,AdminIntegrationsCrmIndexRoute: AdminIntegrationsCrmIndexRoute,AdminIntegrationsXeroIndexRoute: AdminIntegrationsXeroIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,AcceptRoleTokenRoute: AcceptRoleTokenRoute,AdminSplatRoute: AdminSplatRoute,FSlugRoute: FSlugRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute,AboutIndexRoute: AboutIndexRoute,AdminIndexRoute: AdminIndexRoute,AuthIndexRoute: AuthIndexRoute,HealthIndexRoute: HealthIndexRoute,HomeIndexRoute: HomeIndexRoute,InstallIndexRoute: InstallIndexRoute,LegalIndexRoute: LegalIndexRoute,OsIndexRoute: OsIndexRoute,ThemeDemoIndexRoute: ThemeDemoIndexRoute,VrPlaygroundIndexRoute: VrPlaygroundIndexRoute,AuthLinkedinCallbackRoute: AuthLinkedinCallbackRoute,AuthTiktokCallbackRoute: AuthTiktokCallbackRoute,AuthCallbackIndexRoute: AuthCallbackIndexRoute,AuthConfirmIndexRoute: AuthConfirmIndexRoute,AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,AuthGoogleCallbackIndexRoute: AuthGoogleCallbackIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)